import $ from 'jquery';

$(function () {
  let paramsHash = {};
  let paramsArray = window.location.search.slice(1).split('&');
  for (var i = 0; i < paramsArray.length; i++) {
    let param = paramsArray[i].split('=');
    paramsHash[param[0]] = param[1];
  }

  if (paramsHash['type'] === 'article') {
    $('.top-nav-search-input').val('');
  }
});
